export default {
  language: {
    'de': 'German',
    'en-US': 'English',
  },
  view: {
    profile: {
      title: 'Account Profile',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      gender: 'Gender',
      notifications: {
        header: 'I agree to receive the following Mail Notifications',
        jobNote: 'New comment',
        application: 'New Application',
      },
      profilePanelTitle: 'Profile Picture',
      uploadProfilePicture: 'Upload',
      deleteProfilePicture: 'Remove Profile Picture',
      resetPassword: 'Change Password',
      cancel: 'Cancel',
      save: 'Save',
      passwordExplain:
        'You will receive an email with a link to change your password.',
      deleteAccount: 'Delete Account',
      deleteAccountConfirmation:
        'Are you sure you want to delete your account?',
      language: 'Language',
      reset: {
        title: 'Change Password',
        button: {
          label: 'Change Password',
        },
      },
    },
    accountSettings: {},
    login: {
      title: 'Log in to your Recruiter Account',
      registerNow: "Don't have a Recruiter account yet? <0>Register Now</0>",
      forgotPassword: 'Forgot your password?',
      fields: {
        email: {
          title: 'Email',
          placeholder: 'Email',
        },
      },
      buttons: {
        login: {
          label: 'Log In',
        },
        register: {
          label: 'Register',
        },
      },
      info: {
        REGISTRATION_SUCCESS:
          'You have successfully completed your registration. Please log in.',
      },
    },
    legalPanel: {
      termsAndConditions: 'Terms & Conditions',
      imprint: 'Imprint',
      privacyPolicy: 'Privacy Policy',
      manageCookies: 'Manage Cookies',
      faq: 'FAQ',
    },
    logout: {
      buttons: {
        logout: 'Log Out',
        stay: 'Stay Logged In',
      },
    },
    resetPassword: {
      title: 'Reset Password',
      registerNow: "Don't have a Recruiter account yet? <0>Register Now</0>",
      forgotPassword: 'Forgot your password?',
      faq: 'FAQ',
      termsAndConditions: 'Terms & Conditions',
      imprint: 'Imprint',
      privacyPolicy: 'Privacy Policy',
      fields: {
        email: {
          title: 'Email',
          placeholder: 'Email',
        },
      },
      buttons: {
        reset: {
          label: 'Reset',
        },
      },
      info: {
        START_PASSWORD_RESET_FLOW_SUCCESS:
          'You have received an email to reset your password.',
      },
    },
    register: {
      title: 'Create an employer profile now and start a recruiting campaign.',
      alreadyRegistered: 'Already have an account? <0>Log In</0>',
      disclaimer:
        'I have read the <0>Privacy Policy</0> and agree to the general terms and conditions. You can withdraw this consent at any time.',
      fields: {
        email: {
          title: 'Email',
          placeholder: 'Email',
        },
        company: {
          title: 'Company Name',
          placeholder: 'Company Name',
          hint: 'Your legally registered company name, e.g., funnellab GmbH',
        },
        firstName: {
          title: 'First Name',
          placeholder: 'First Name',
        },
        lastName: {
          title: 'Last Name',
          placeholder: 'Last Name',
        },
        phone: {
          title: 'Phone',
          placeholder: 'Phone',
        },
      },
      buttons: {
        register: {
          label: 'Register',
        },
      },
      errors: {
        reCaptchaIncomplete: 'Please confirm that you are not a robot.',
        registrationFailed:
          "Registration could not be completed. Please check whether your organization is already registered. Contact your organization's administrator for an invitation or try again via the login page if you already have an account.",
      },
    },
    verifyEmail: {
      sidePanel: {
        header: 'We need to verify your email before we proceed.',
      },
      form: {
        header: 'Verification',
        description: 'Enter verification code sent to email',
        placeholder: 'Enter verification code',
        button: 'Verify',
        resendCode: 'Resend code',
        errorMessage:
          'The token is incorrect or has already expired.\nPlease request a new token and try again',
      },
    },
    organizationInvite: {
      fields: {
        inviteeEmailAddress: {
          title: 'Email',
          placeholder: 'Email',
        },
      },
      buttons: {
        invite: {
          label: 'Invite',
        },
      },
    },
    organizationInviteAccept: {
      buttons: {
        accept: {
          label: 'Accept Invitation',
        },
      },
      errors: {
        unknown: 'Unknown error',
      },
    },
    error: {
      apology: 'Oops, something went wrong',
      retry: 'Retry',
      details: 'Error details:\n{{errorMessage}}\n\n{{stack}}',
      buttons: {
        logout: 'Log Out',
        backToDashboard: 'Back to Home',
      },
      serverUnavailable: 'Our Server is currently unavailable.',
    },
    update: {
      buttonLabel: 'Update now',
      title: 'New version available',
    },
    jobs: {
      title: 'Jobs',
      addJob: 'New Job',
      columnId: 'ID',
      columnTitle: 'Title',
      columnStatus: 'Status',
      columnOrganization: 'Organization',
      columnDateUpdated: 'Last modified on',
      deleteJobConfirmation: 'You are about to delete a job. Are you sure?',
      edit: 'Edit Job',
      delete: 'Delete Job',
      duplicate: 'Copy Job',
      terminate: 'Cancel',
      terminateInfoText:
        'By cancelling, only the current campaign will be terminated on {{endDate}}. Your account with funnellab will remain active and you can start new campaigns at any time.',
      terminationModal: {
        title: 'Are you sure you want to unsubscribe?',
        subTitle: 'If confirmed, your subscription ends on {{endDate}}.',
        acceptLabel: 'Cancel subscription',
      },
      withdrawTermination: 'Withdraw Cancellation',
      publish: 'Publish',
    },
    organizationList: {
      title: 'Organizations',
      addJob: 'New Job',
      addOrganization: 'New Organization',
      delete: {
        tooltip: 'Delete organization',
        confirmation:
          "You are about to delete the organization {{name}}.\nThis organization may still contain invited and active recruiters, as well as jobs in the status '$t(common:jobStatus:offline)' or '$t(common:jobStatus:draft)'.\nAre you sure you want to proceed?",
        error:
          'The organization {{name}} could not be deleted. Please check for any blocking links and try again.',
      },
    },
    chatbot: {
      popupHeader: 'Share Chatbot',
      linkHeader: 'Link',
      instructionsHeader: 'Embed Code',
      done: 'Done',
      linkCopiedToClipboard: 'The link was successfully copied.',
      embedCodeCopiedToClipboard: 'The embed code was successfully copied.',
      owner1_german_sie:
        'Herzlich willkommen! Etwas hat mit der Übersetzung nicht funktioniert',
      owner1_german_du:
        'Herzlich willkommen! Etwas hat mit der Übersetzung nicht funktioniert',
      owner1_english:
        'Welcome to our website! 👋 Thank you for taking the first step. Now check whether this job suits you.',
      user_companyDescription: 'What can I expect?',
      user_tasks: 'What do my tasks look like?',
      user_qualifications: 'What qualifications should I have?',
      user_benefits: 'Which benefits can I expect?',
      choose: 'Choose an option',
      freeTextPlaceholder: 'Enter here...',
      continue: 'Continue',
      startPeriod: {
        now: 'Now',
        month_1: 'In about 1 month',
        month_2: 'In about 2 months',
        month_3: 'In about 3 months',
        month_3_plus: 'Later than in 3 months',
      },
      contact: {
        translationError:
          'Etwas hat mit der Übersetzung nicht funktioniert. Bitte kontaktieren Sie den Support.',
        owner_wrapup_german_sie: '$t(view.chatbot.contact.translationError)',
        owner_wrapup_german_du: '$t(view.chatbot.contact.translationError)',
        owner_wrapup_english:
          "Great, that's almost it! Finally, we ask you to provide your contact details (name, email, and phone number) so that your potential employer, **{{employer_brand}}**, can reach you.",
        owner_privacy_german_sie: '$t(view.chatbot.contact.translationError)',
        owner_privacy_german_du: '$t(view.chatbot.contact.translationError)',
        owner_privacy_english:
          "🔐 We treat your data with the utmost confidence and only use it in connection with applications. You hereby confirm that you have understood and agree to funnellab's privacy policy. Can we continue?",
        name_german_sie: '$t(view.chatbot.contact.translationError)',
        name_german_du: '$t(view.chatbot.contact.translationError)',
        name_english: 'What is your **name (first and last name)?**',
        zipCode_german_sie: '$t(view.chatbot.contact.translationError)',
        zipCode_german_du: '$t(view.chatbot.contact.translationError)',
        zipCode_english:
          'Please enter the **ZIP code of your residence** so that we can estimate the distance to the workplace.',
        phone_german_sie: '$t(view.chatbot.contact.translationError)',
        phone_german_du: '$t(view.chatbot.contact.translationError)',
        phone_english:
          '☎ If we have any questions about your application, we would be happy to contact you by phone. What is your phone number (e.g., **+49 151126000012)?**',
        email_german_sie: '$t(view.chatbot.contact.translationError)',
        email_german_du: '$t(view.chatbot.contact.translationError)',
        email_english:
          "📧 If we can't reach you by phone, we'll contact you by email. What is your **email address?**",
      },
      privacy: {
        yes: 'Yes',
        privacy: 'Privacy Policy',
        link: 'https://www.funnellab.com/en/privacy-policy',
      },
      accept: {
        german_du: '$t(view.chatbot.contact.translationError)',
        german_sie: '$t(view.chatbot.contact.translationError)',
        english:
          'Thank you for your application!\
Your potential employer, **{{employer_brand}}**, will contact you shortly to discuss the next steps in your application.\
The initial contact will usually be by phone.',
      },
      reject: {
        german_du: '$t(view.chatbot.contact.translationError)',
        german_sie: '$t(view.chatbot.contact.translationError)',
        english:
          'Thank you for your application! \
We have compared your information with the requirements of the employer **{{employer_brand}}** and have determined that you do not meet at least one of the requirements for the position. \
However, we will add you to the funnellab® talent pool and contact you as soon as we have a position that might be a good fit for you!',
      },
      toCompany: 'To Company',
      source: 'Source',
      appliedAT: 'Applied at',
    },
    chatbotBuilder: {
      answerRating: {
        ideal: 'Ideal',
        possible: 'Possible',
        reject: 'Reject',
      },
      addAnswer: 'Add answer',
      publishChanges: 'Publish changes',
      sidePanel: {
        mode: {
          title: 'Mode',
          live: 'Live',
          draft: 'Draft',
          preview: 'Preview',
        },
        content: 'Content',
        questions: 'Questions',
        companyDescription: 'Company',
        tasks: 'Job Tasks',
        qualifications: 'Qualifications',
        benefits: 'Benefits',
        addCustomQuestion: 'Add custom question',
        questionDeleteConfirmation:
          'Deleting a question is an irreversible thing.',
      },
      attribute: {
        qualification: 'Qualification',
        qualification_description:
          'What training or degree should applicants have?',
        experience: 'Experience',
        experience_description:
          'Which professional experience should applicants have?',
        languageSkill: 'Language Skills',
        languageSkill_description:
          'A maximum of two language skills questions can be asked.\n\
        A good language skills question should ask about a language and offer different levels as answer options.',
        lastJob: 'Last Job',
        lastJob_description: 'What was the applicants last job?',
        openText: 'Open Text',
        openText_description:
          'Question that applicants can answer with free text.',
        startPeriod: 'Start Period',
        startPeriod_description: 'When can the position be started?',
        custom: 'Custom',
        custom_description: 'User defined Question',
        freeTextShort: 'short (255 Characters)',
        freeTextLong: 'long (1024 Characters)',
        deleteQuestion: 'Delete question',
        hideQuestion: 'Hide question',
        displayQuestion: 'Display question',
      },
      questionType: {
        singleChoice: 'Single Choice',
        multipleChoice: 'Multiple Choice',
        freeTextShort: 'Free Text',
        rating: 'Rating',
      },
      configEditor: {
        description:
          'The first step is done. Now check if the information is correct.',
      },
      questionEditor: {
        question: 'Question Text',
        enterQuestion: 'Enter your question here',
        answerOptions: 'Answer Options',
        questionTooltip: 'This question will be asked to potential applicants.',
        selectAnswerType: 'Select Answer Type',
      },
      errors: {
        publishFailed: 'Failed to publish changes',
        updateFailed: 'Failed to update configuration',
      },
    },
    support: {
      header: 'Support',
      mailLabel: 'Contact support',
      callLabel: 'Give us a call',
      faqHeader: 'FAQ',
      question1: 'How do I create a social recruiting campaign with Funnellab?',
      answer1:
        'Campaign creation is simple and structured. Click on “New job” and follow the individual steps. You can upload an existing job advertisement so that all relevant information is automatically transferred. Alternatively, our intelligent input wizard will help you to enter all the important data step by step and prepare it optimally for the campaign.\n\nDuring the process, you will also receive automatic suggestions based on your job title as well as explanatory info boxes to help you provide the correct information',
      question2: 'Can I edit or pause an existing campaign?',
      answer2:
        "Yes, you have full flexibility! As long as the campaign is in 'draft' status, you can make adjustments at any time using our intuitive campaign editor. After publication, our performance recruiters will be at your side to implement targeted and optimized changes. This is how we ensure that your campaign always achieves the best results",
      question3: 'How does the pre-qualification of applicants work?',
      answer3:
        'Applicant pre-qualification is carried out by an automated chatbot that asks targeted questions to check the suitability of candidates. As a result, only qualified applications are forwarded, which increases the efficiency of the selection process.',
      question4: 'Where can I view my incoming applications?',
      answer4:
        'Currently, all applications are forwarded directly to your applicant management tool (ATS). An integrated solution for direct management within Funnellab is already being planned',
      question5: 'How do I receive notifications about new applications?',
      answer5:
        'Notifications about new applications are sent by e-mail. You can specify the recipients directly when creating the campaign or adjust them later in the respective job',
      question6: 'Can I manage several job advertisements at the same time?',
      answer6:
        'Yes, there is no limit to the number of active jobs. You can place and manage several campaigns at the same time',
      question7: 'How are suitable candidates found?',
      answer7:
        "Funnellab uses funnel recruiting to target tens of thousands of potential candidates via social media. Your job ad is delivered to exactly the right audience, and interested candidates go through our smart recruiting chatbot that efficiently guides them through the application process.\n\nOur AI-powered matching technology analyzes applicants' responses and their digital footprint to ensure the right talent is targeted. This way, we maximize the chances of attracting qualified applicants for your open position",
      question8: 'How is the recruiting budget calculated?',
      answer8:
        'The recruiting budget is set individually based on the job category - depending on whether you are looking for junior staff, support staff, specialists or managers. You also have the option of using the boost function to increase the reach and visibility of your campaign in a targeted manner',
    },
    coaching: {
      header: 'Academy',
      bucket1: 'Social recruiting: how it works!”',
    },
  },
  menu: {
    organizations: 'Organizations',
    employerBrands: 'Employer Brands',
    jobs: 'Jobs',
    contacts: 'Contacts',
    close: 'Close',
    profile: 'Profile',
    logout: 'Log Out',
    termsAndConditions: 'Terms & Conditions',
    imprint: 'Imprint',
    privacyPolicy: 'Privacy Policy',
    support: 'Support',
    coaching: '$t(view:coaching:header)',
    more: 'More',
  },
  formValidation: {
    requirements: 'Requirements',
    invalidInput: 'Please check your input.',
    empty: 'This field cannot be empty.',
    tooLong: 'Input is too long ({{length}}/{{maxLength}}).',
    tooLongArray:
      'You may add a maximum of {{maxLength}} entries (currently {{length}}).',
    tooShort: 'at least {{minLength}} characters',
    mustContain: 'at least 1 {{example}}',
    mustNotContain: 'no {{example}}',
    earliestPossibleDate: 'The earliest possible date is {{referenceDate}}.',
    latestPossibleDate: 'The latest possible date is {{referenceDate}}.',
    tooShortArray:
      'Please add at least {{minLength}} entries (currently {{length}}).',
    outOfRangeMin: 'The input must be at least {{min}}.',
    outOfRangeMax: 'The input can be at most {{max}}.',
    outOfRangeMinMax: 'The input must be between {{min}} and {{max}}.',
    equals: 'The inputs do not match.',
    noDuplicates: 'The entry already exists.',
    wrongFormat: 'The input has an invalid format.',
    emailWrongFormat: 'Please check your email address input.',
    zipWrongFormat: 'Please check your ZIP code input.',
    radiusRequired: 'Please enter a radius (min. 17km, max. 80km).',
    notEqual: 'The inputs do not match.',
    duplicate: 'This value already exists.',
    whitespace: 'whitespace',
    lowercase: 'lowercase letter (a-z)',
    uppercase: 'uppercase letter (A-Z)',
    specialChar: 'special character',
    number: 'digit (0-9)',
    email: 'Please enter a valid email address',
    invalidUrl: 'Please enter a valid URL (e.g. https://example.com).',
    invalidPhoneNumber:
      'Please enter a valid phone number for {{countryCode}}.',
    invalidVatNo:
      'The VAT identification number is invalid. Valid format: {{valid_vat_no}}.',
    countryFilter: 'Filter Country',
    duplicateOrganization:
      'Organization Creation could not be completed. Please check whether your organization already exists. Contact your administrator for further information.',
  },
  table: {
    dateFormat: '$t(common:dateFormat)',
    yes: '$t(common:yes)',
    no: '$t(common:no)',
    search: 'Search',
    totalResults: 'Items found: {{total}}',
    selected: 'Selected: {{selected}} of {{total}}',
    deselectAll: 'Deselect All',
    noEntry: 'No entries found',
    organization: {
      externalId: 'ID',
      name: 'Name',
      employerBrands: 'Linked Employer Brands',
      jobs: 'Jobs',
    },
  },
  upload: {
    rejected: 'Rejected',
    uploadProgress:
      '{{progressInPercent, number(maximumFractionDigits: 0)}}% uploaded',
    uploadedFileSize: ' {{fileSize}}',
    tryAgain: 'Upload Again',
    uploadClick: 'Click to upload',
    uploadDragAndDrop: 'or Drag & Drop',
    or: 'or',
    acceptedFileFormats: '{{acceptedFileFormats}}',
    fileSizeRestriction: ' (max. {{maxFileSize}})',
    unknownError: 'Unknown error',
    fileTooLarge: 'File is too large',
    unknownFileType: 'Unknown file type',
    tooManyFiles: 'Too many files',
  },
  paginationPanel: {
    previous: 'Previous',
    next: 'Next',
    pageOf: 'Page {{currentPage}} of {{numberOfPages}}',
  },
  jobWizard: {
    stepGeneral: {
      label: 'What are you <highlight>looking for</highlight>?',
    },
    stepEducation: {
      label: 'What <highlight>requirements</highlight> does this role have?',
    },
    stepSkills: {
      label: 'Which <highlight>skills</highlight> does the position require?',
      infoBox:
        "Tip: Define the relevant skills as 'can' or 'must'. This allows the AI to better understand the target group and optimize the algorithm in a targeted manner.",
    },
    stepTargetGroup: {
      label: 'Who is the <highlight>target group</highlight>?',
      generatedHook: 'Generated Hook',
      hookInfoText:
        'The first sentence of the ad is automatically generated from the information and location - and is intended to directly address suitable applicants.',
    },
    stepLocation: {
      label: 'Where should the <highlight>campaign</highlight> be shown?',
    },
    stepSoftSkills: {
      label:
        'Which <highlight>soft skills</highlight> does the position require?',
    },
    stepTasks: {
      label: 'Which <highlight>tasks</highlight> will be performed?',
    },
    stepEmployerBrand: {
      label: 'Choose your <highlight>employer brand</highlight>!',
    },
    stepBenefits: {
      label: 'Which <highlight>benefits</highlight> do you offer?',
    },
    stepSalary: {
      label: 'What is the <highlight>salary</highlight>?',
      infoBox:
        'A clearly communicated salary increases transparency, strengthens trust and ensures that only genuinely interested and suitable people apply - this saves time and improves conversion.',
    },
    stepContacts: {
      label: 'Who should have <highlight>access</highlight>?',
    },
    stepOrganization: {
      label: 'Choose your <highlight>organization</highlight>!',
      alertText:
        'The organization is the billing entity. Here you store the data of the company that pays for the campaign.\nIn the next step (Employer Brand), you define how the company is presented externally.',
    },
    stepFiles: {
      label:
        'Do you have any <highlight>job-specific marketing materials</highlight>?',
      title: 'Images/Videos for your ad',
      infoText:
        'Upload any images or videos you wish to use specifically for this campaign. For larger files (>20 MB), please use external links (e.g. WeTransfer, Google Drive).',
    },
    stepPriceCalculation: {
      label: 'How many <highlight>employees</highlight> are you looking for?',
      title: 'Publish Social Recruiting Campaign',
      nextButton: 'Enter Billing Information',
      averageHiringTimeInfoText:
        '<strong>Average hiring time:</strong> For this type of job, the average time-to-hire is around 76 days. Therefore, we recommend 3 months.',
      flexibleUseHintText:
        '<strong>Flexible use:</strong> If the position is filled sooner, the remaining months will be credited.',
    },
    stepBillingAddress: {
      label: '<highlight>Social Recruiting Campaign</highlight> – Book Now',
      highlight1: 'Reach passive job seekers on social media',
      highlight2: 'Prequalify candidates with a chatbot',
      highlight3: 'AI-optimization based on top applicants',
      nextButton: 'Book Campaign',
      termsAndConditions: 'https://www.funnellab.com/en/terms-and-conditions',
    },
    stepPayment: {
      nextButton: 'Pay now',
      errors: {
        paymentSession: 'Unknown error when loading the payment step',
      },
    },
    educationInput: {
      title: 'Which training or degree is required?',
      placeholder: 'Training/Degree',
      infoText:
        'List the relevant degrees or qualifications required for this position.',
    },
    experienceInput: {
      title: 'Which work experience is required?',
      placeholder: 'Work experience',
      infoText: 'Please list the required experiences for this position.',
    },
    fullTimeInput: {
      title: 'Type of Employment',
      fullTime: 'Full-time',
      partTime: 'Part-time',
      infoText:
        'Choose whether this position is offered as full-time, part-time, or both.',
    },
    skillInput: {
      title: 'Skills',
      addOption: 'Add skill',
      addedSkills: 'Added Skills ({{count}}/{{max}})',
      placeholder: 'Knowledge/Permissions',
      mustHave: 'Must',
      niceToHave: 'Nice to have',
      infoText:
        'List any specific knowledge or abilities required for this position.',
    },
    softSkillInput: {
      title: 'Soft skills',
      placeholder: 'Soft skills',
      infoText:
        'List the soft skills that are particularly important for this position, e.g. teamwork.',
    },
    taskInput: {
      title: 'Add tasks:',
      placeholder: 'Task',
      infoText:
        'Please enter at least 3 tasks and up to 6 tasks that clearly describe the role.',
      errorMessage: 'Please add at least 3 tasks',
    },
    targetJobTitlesInput: {
      title: 'Candidates with the following job titles:',
      placeholder: 'Job Title',
      infoText:
        'Optional. If certain job titles are typical for the target audience, enter 1-3 here.',
    },
    targetCareerJumpersInput: {
      title: 'Career changers welcome?',
      infoText:
        'Choose whether applicants without direct experience in this field will also be considered.',
    },
    targetExperienceEducationInput: {
      title: 'Candidates with the following experience and degrees:',
      placeholder: 'Experience and degrees',
      infoText:
        'Optional. If certain experiences or qualifications are typical for the target audience, enter one or two here.',
    },
    workExperienceInput: {
      title: 'How much professional experience is necessary at minimum?',
      NONE: 'None',
      LESS_THAN_ONE_YEAR: 'Less than 1 year',
      ONE_TO_TWO_YEARS: '1-2 years',
      THREE_TO_FIVE_YEARS: '3-5 years',
      SIX_TO_TEN_YEARS: '6-10 years',
      MORE_THAN_TEN_YEARS: 'More than 10 years',
      infoText:
        'Select the minimum length of experience required for this position.',
    },
    jobTitleInput: {
      title: 'Job Title',
      placeholder: 'Job Title',
      infoText:
        'Select a title that clearly describes the position and appeals to potential employees.',
    },
    jobOrganizationInput: {
      title: 'Organization',
      placeholder: 'Organization',
      addOption: 'Add organization',
      errorUserRequired: 'User not found.',
      infoText:
        'Select the organization that will publish this campaign and also appear as the invoice recipient.',
    },
    jobBillingAddressInput: {
      title: 'Billing Address',
      infoText: 'Enter the address that should appear on the invoice.',
    },
    jobPaymentForm: {
      title: 'Payment Method',
      chooseMethod: 'Select Payment Method',
      summary: 'Summary',
      infoText: '',
      saveForFuturePayments: 'Save this for future  payments',
      grandTotal: 'Grand Total (gross)',
      header: {
        job: 'Job',
        quantity: 'Quantity',
        unit_amount: 'Unit price',
        total_amount: 'Total',
      },
      month_one: '1 month',
      month_other: '{{count}} months',
      error: {
        unknownStripeError: 'Unknown error during payment',
        organizationNotSet: 'The organization is not set',
        countryNotSet: 'The country is not set',
        organizationUpdate: 'Error updating the organization',
        priceChanged: 'The price has changed. Please reload the page.',
      },
    },
    jobOrganizationBillingEmailInput: {
      title: 'Billing Email',
      placeholder: 'Billing Email',
    },
    jobOrganizationStreetInput: {
      title: 'Street, House Number',
      placeholder: 'Street, House Number',
    },
    jobOrganizationZipInput: {
      title: 'ZIP Code',
      placeholder: 'ZIP Code',
    },
    jobOrganizationCityInput: {
      title: 'City',
      placeholder: 'City',
    },
    jobOrganizationCountryInput: {
      title: 'Country',
      placeholder: 'Country',
    },
    jobOrganizationVatNoInput: {
      title: 'VAT ID',
      placeholder: 'VAT ID',
    },
    jobInvoiceReferenceInput: {
      title: 'Invoice Reference',
      placeholder: 'Invoice Reference',
    },
    jobEmployerBrandInput: {
      title: 'Employer Brand',
      placeholder: 'Employer Brand',
      addOption: 'Add employer brand',
      errorOrganizationRequired: 'Please select an organization first.',
      errorUserRequired: 'User not found.',
      infoText:
        'Under which employer brand should the campaign be published? This may differ from the organization name.',
      updateAlert:
        'You are currently in the process of updating your employer brand. The new brand name will be used in the future instead of the previous one.',
    },
    jobEmployerBrandBenefitsInput: {
      title: 'The following benefits apply to the entire employer brand',
      placeholder: 'Benefits',
      addOption: 'Add benefits',
      infoText:
        'Enter the general benefits that apply to all positions under this employer brand.',
    },
    jobBenefitsInput: {
      title: 'The following benefits apply specifically to this position',
      placeholder: 'Benefits',
      infoText: 'List the specific benefits that only apply to this position.',
    },
    jobEmployerBrandDescriptionInput: {
      title: 'Company Description',
      placeholder:
        'Describe your employer brand in 4–8 sentences. You may copy from your website and paste it here.',
      infoText:
        'Describe your company in 4–8 sentences to give applicants a clear impression of your employer brand.',
    },
    jobEmployerBrandHomepageInput: {
      title: 'Website / Career Page',
      placeholder: 'Website / Career Page',
      infoText:
        'Provide the URL of your website or career page so interested parties can learn more about your company.',
    },
    jobEmployerBrandCIGuidelinesInput: {
      title: 'Corporate Identity Guidelines',
      placeholder:
        'Please describe your corporate identity (CI) in 4–8 sentences, possibly including your brand values, vision, and mission. Alternatively, we can refer to your website.',
      infoText:
        'Your guidelines ensure a consistent campaign in your brand’s look & feel. Alternatively, you can direct us to your website.',
    },
    jobEmployerBrandCIDocumentsInput: {
      description: 'CI documents, logos, images, etc. max 20MB, max 20 files',
    },
    jobAddressingInput: {
      title: 'Form of address for candidates',
      placeholder: 'Form of address',
      english: 'English',
      german_sie: 'German (Sie)',
      german_du: 'German (Du)',
    },
    salaryTypeInput: {
      title: 'Salary',
      perMonth: 'per month',
      perYear: 'per year',
      perHour: 'per hour',
      infoText:
        'Indicate the salary, either as a monthly or yearly amount, for transparency.',
    },
    salaryRangeInput: {
      title: 'Range',
      min: 'from',
      max: 'to',
      infoText:
        'Define a salary range to provide candidates with an orientation. If desired, you can specify if this should be visible in the campaign.',
    },
    showSalaryInput: {
      title: 'Should the salary range be mentioned in the recruiting campaign?',
    },
    contactsInput: {
      title: 'Add recruiters who will have access to applications:',
      placeholder: 'Contacts',
      addOption: 'Add contact',
      errorOrganizationRequired: 'Please select an organization first.',
      errorLoadingRecruiters: 'Error loading contacts',
    },
    locationInput: {
      title: 'Location or Region:',
      placeholder: 'Address/Country',
      infoText:
        'Enter the job location to target applicants from the appropriate region. You can also select countries, states, or specific areas.',
      locationTypeLabel: {
        street_address: 'Address',
        route: 'Street',
        locality: 'City',
        sublocality: 'Region',
        postal_code: 'Region',
        administrative_area_level_1: 'Region',
        administrative_area_level_2: 'Region',
        administrative_area_level_3: 'City',
        country: 'Country',
      },
      radiusSuffix: 'km',
    },
    jobFilesInput: {
      description: 'Images, videos, etc. max 20MB, max 20 files',
    },
    jobLinksToExternalFilesInput: {
      title:
        'Links to external drives (WeTransfer, Google Drive, Dropbox, OneDrive, etc.)',
      placeholder:
        'If you want to provide files larger than 20 MB, please use external drives or WeTransfer and post the link here.',
    },
    unsavedChangesWarning:
      'You have unsaved changes. Do you really want to leave this page?',
    jobNumberOfPlannedHiresInput: {
      title: 'Number of Planned Hires',
      infoText:
        'Enter the number of employees you want to hire with this campaign.',
      hires_one: '1 employee',
      hires_other: '{{count}} employees',
    },
    jobRuntimeInput: {
      title: 'Duration',
      infoText:
        'Select the desired campaign duration. The duration affects visibility and reach.',
    },
    jobStartDateInput: {
      title: 'Start Date',
      infoText: 'Select the desired campaign start date.',
    },
    jobBoostInput: {
      title: 'Use a boost to get more applicants',
      infoText:
        'Increase visibility and reach up to 20,000 additional potential candidates.',
    },
    jobAcceptTermsAndConditionsInput: {
      title: 'I accept the <0>Terms & Conditions</0>',
      infoText:
        'Please confirm that you have read and accepted the Terms & Conditions to book the campaign.',
    },
    importAlert: {
      title: 'Import your job ad and launch your recruiting campaign faster!',
      body: 'Easily import job ads into funnellab – just provide the title and description, and it will be prefilled automatically.',
      button: { label: 'Import Job Ad' },
    },
    importModal: {
      title: 'Import your job ad in seconds!',
      text: 'Import job ads from your website – just add the title and description, we’ll handle the rest.',
      infoText:
        'This feature is based on AI. The content you use or create is your responsibility. funnellab assumes no liability. Use personal data and business secrets only if you are authorized to do so.',
      inputs: {
        title: { placeholder: 'Job title', title: 'Job title' },
        description: {
          placeholder: 'Job description',
          title: 'Job description',
        },
      },
      errorMessage: 'The job could not be imported. Please try again.',
      button: {
        label: 'Import Now',
      },
      loading: {
        title: 'Analyzing your job ad…',
        text: 'Processing your details – this takes just a moment.',
        button: { label: 'Stop Import' },
      },
    },
  },
  common: {
    password: {
      title: 'Password',
      placeholder: 'Password',
      error: 'The password does not meet the requirements.',
    },
    passwordConfirm: {
      title: 'Password (repeat)',
      placeholder: 'Repeat password',
      error: 'The passwords do not match.',
    },
    combobox: {
      optionSelectError: 'Please select an option from the list.',
      addButtonLabel: 'Add option',
      editButtonLabel: 'Edit option',
    },
    numberInput: {
      increment: 'Increase value',
      decrement: 'Decrease value',
    },
    textInputWithOptions: {
      dropDownButtonLabel: 'Show options',
    },
    discard: 'Discard',
    submitChanges: 'Publish Changes',
    dateFormat: 'MM/DD/YYYY',
    yes: 'Yes',
    no: 'No',
    delete: 'Delete',
    button: {
      next: 'Next',
      previous: 'Back',
      save: 'Save',
      saveAsDraft: 'Save as Draft',
      close: 'Close',
      logout: 'Log Out',
      cancel: 'Cancel',
      confirm: 'Confirm',
      finishWizard: 'Enter Billing Information',
      add: 'Add',
    },
    recommended: 'recommended',
    attention: 'Attention',
    wizard: {
      step: 'Step {{current}}/{{total}}',
    },
    addRow: 'Add row',
    errors: {
      INVALID_PAYLOAD: 'Invalid data',
      INVALID_RESPONSE: 'Invalid Response',
      INVALID_API_RESPONSE: 'Invalid API Response',
      FAILED_VALIDATION: 'Validation failed',
      unknown: 'Unknown error',
      NETWORK_ERROR: 'Network error',
      INVALID_CREDENTIALS: 'Incorrect username or password',
      UNAUTHORIZED: 'No access rights',
      TOKEN_EXPIRED: 'Session expired',
      NOT_FOUND: 'Item not found',
      REGISTRATION_FAILED: 'Registration failed',
      UNPROCESSABLE_ENTITY: 'Internal Server error',
      CONFLICT: 'Internal Server error',
      INVALID_STATUS_TRANSITION: 'The job status could not be changed',
      DUPLICATE_INVITE: 'This email address has already been invited',
      FORBIDDEN: 'No permission',
      errorWhileSaving: 'Error while saving: {{errorMessage}}',
      INCOMPLETE_JOB_DATA: 'Job data is incomplete',
      MISSING_CONFIG: 'Missing Configuration',
      PAYMENT: 'Error processing payment data',
      // ToDo: This should not happen -> We need a better errorMapping function!
      NOTHING_TO_DO: 'Invalid data',
    },
    jobStatus: {
      draft: 'Draft',
      submitted: 'Submitted',
      online: 'Online',
      online_terminated: 'Online until {{liveUntil}}',
      offline: 'Offline',
      reactivating: 'Reactivating',
      unknown: 'Unknown',
    },
    gender: {
      male: 'Male',
      female: 'Female',
      other: 'Other',
    },
    role: {
      Admin: 'admin',
      Member: 'member',
    },
    empty: 'Nothing to show here right now.',
    notSet: 'No display value available',
    suggestions: 'Suggestions',
    validUntil: 'valid until',
    timeUnits: {
      short: {
        minute: '{{count}}m',
        hour: '{{count}}h',
        day: '{{count}}D',
        week: '{{count}}W',
        month: '{{count}}M',
        year: '{{count}}Y',
      },
      long: {
        second_one: '1 second',
        second_other: '{{count}} seconds',
      },
    },
    user: {
      unknownUser: 'Unknown User',
    },
  },
  slider: {
    minimum: 'Minimum',
    maximum: 'Maximum',
  },
  errorMessages: {
    failedToAddOption: 'Error adding entry',
    email: 'Please enter a valid email address',
  },
  jobCreatedModal: {
    close: 'Close',
    success: 'Success',
    successMessage: 'You have created a new job!',
  },
  errorModal: {
    title: 'An error occurred',
    description: 'Please try again or contact support with the error details.',
    details: 'Error details',
    close: 'Close',
  },
  recruiterView: {
    tabHeaderAccepted: 'Members',
    tabHeaderInvited: 'Membership Requests',
    inputPlaceholder: 'Email address or name',
    buttonLabel: 'Invite',
    tooltipAdminRole:
      'Admin user: Full access to all jobs in the organization.',
    tooltipMemberRole:
      'Member user: Access only to their own jobs and jobs where they are listed as a recruiter.',
    resendInvite: 'Resend invite',
  },
  jobDetails: {
    overview: 'Overview',
    general: 'General',
    applicants: 'Applicants',
    funnel: 'Funnel',
    recruiter: 'Recruiter',
    recruiter_other: '{{count}} Recruiter',
    contact: 'Schedule a Meeting',
    organization: 'Organization',
    employerBrand: 'Employer\u00A0Brand',
    invoiceReference: 'Invoice\u00A0Reference',
    campaignBudget: 'Campaign\u00A0Budget',
    campaignId: 'Campaign ID',
    perMonth: ' / month',
    nextRenewal: 'Next Renewal',
    history: 'History',
    tabNotes: 'Notes',
    notesPlaceholder:
      'Make a note for your colleagues, the social recruiting expert, and yourself.',
    tabFiles: 'Files',
    errorUpdatingJob: 'Error while saving: {{errorMessage}}',
    ad: 'Ad',
    geotargeting: 'Geo-Targeting',
    creatives: 'Creatives',
    recruiterPopup: {
      modalTitel: 'Invite recruiter',
    },
    chatbot: 'Chatbot',
    share: 'Share',
    unknownCategory: 'Uncategorized',
    categoryTitle: '{{category}} ({{count}})',
    story: 'Story',
    post: 'Post',
    stockImage: 'Stock Image',
    migrationHint: {
      text: 'Attention, this job was migrated automatically. Information may be missing!',
      creatives: 'Creatives',
      adText: 'Ad Text',
      chatbot: 'Chatbot',
      trelloLink: 'Applicants Link',
      metaCampaign: 'meta Campaign',
      button: 'Job is complete',
    },
    ats: {
      menu: {
        manageLabels: 'Manage labels',
        showCCandidates: 'Show C Candidates',
        hideCCandidates: 'Hide C Candidates',
      },
      defaultPhases: {
        applied: 'Applied',
        qualificationCall: 'Qualification Call',
        videoInterview: 'Video Interview',
        interview: 'Interview',
        trialWork: 'Trial Work',
        potentialAnalysis: 'Potential Analysis',
        offer: 'Offer',
        rejected: 'Rejected',
        hired: 'Hired',
      },
      defaultLabels: {
        high: 'high',
        medium: 'medium',
        low: 'low',
      },
      labels: {
        inputPlaceholder: 'Enter a name',
        addLabel: 'Add label',
        deleteConfirmMessage:
          'You are in the process of deleting a label.\nThis label will also be removed from all linked applicants. Would you like to continue?',
      },
      phases: {
        addPhase: 'Add a pipeline',
        placeholder: 'Enter name',
        changeColor: 'Change color',
        addApplicant: 'Add Applicant',
        defaultPhaseTooltip:
          'This application phase is permanently stored in the system and is an essential part of the application process. It can therefore not be edited or deleted.',
      },
      applicant: {
        detail: {
          avatarModalTitle: 'Applicant Image',
          inPhase: 'In List',
          label: 'Label',
          rejectionMailSent: 'Rejection email sent on {{date}}',
          sendRejectionEmail: 'Send rejection email',
          sendRejectionEmailConfirm: {
            title: 'Send rejection email?',
            body: 'After confirmation, the rejection email will be sent to {{applicantName}} ({{applicantEmail}}). Subsequently, the applicant will be automatically moved to the pipeline phase „$t(jobDetails:ats:defaultPhases:rejected)“',
            confirm: 'Send rejection email',
            error:
              'An error occurred while sending the rejection email. Please try again later.',
          },
          userData: {
            header: 'User data',
            telephone: 'Telephone',
            email: 'Email',
            zip: 'Zip code',
            forceShow: 'Always show',
            bestReachability: {
              label: 'Best Reachability',
              morning: 'Morning',
              noon: 'Noon',
              afternoon: 'Afternoon',
              night: 'Night',
            },
          },
          qualifications: {
            header: 'Qualifications',
            qualityLabel: 'Applicant quality',
          },
          attachments: {
            header: 'Attachments',
            showMore: 'Show more',
            showLess: 'Show less',
            add: 'Add document',
          },
          activitiesAndComments: {
            header: 'Activities and Comments',
            phaseChanged:
              '{{name}} moved the applicant from {{oldValue}} to {{newValue}}.',
            bestReachabilityChanged:
              '{{name}} changed the best reachability from {{oldValue}} to {{newValue}}.',
            bestReachabilitySet:
              '{{name}} set the best reachability to {{newValue}}.',
            bestReachabilityRemoved: '{{name}} removed the best reachability.',
            nameChanged:
              '{{name}} changed the name from {{oldValue}} to {{newValue}}.',
            nameSet: '{{name}} set the name to {{newValue}}.',
            nameRemoved: '{{name}} removed the name.',
            emailChanged:
              '{{name}} changed the email from {{oldValue}} to {{newValue}}.',
            emailSet: '{{name}} set the email to {{newValue}}.',
            emailRemoved: '{{name}} removed the email.',
            zipChanged:
              '{{name}} changed the zip from {{oldValue}} to {{newValue}}.',
            zipSet: '{{name}} set the zip to {{newValue}}.',
            zipRemoved: '{{name}} removed the zip.',
            phoneChanged:
              '{{name}} changed the phone number from {{oldValue}} to {{newValue}}.',
            phoneSet: '{{name}} set the phone number to {{newValue}}.',
            phoneRemoved: '{{name}} removed the phone number.',
            attachmentsSet: '{{name}} uploaded the file {{newValue}}.',
            attachmentsRemoved: '{{name}} deleted the file {{oldValue}}.',
            avatarSet: '{{name}} has uploaded an avatar.',
            avatarRemoved: '{{name}} has deleted the avatar.',
            labelsSet: '{{name}} added the label {{newValue}}.',
            labelsRemoved: '{{name}} removed the label {{oldValue}}.',
            rejectionEmailSent: '{{name}} sent a rejection email',
            allActivities: 'All Activities',
            onlyComments: 'Comments',
          },
        },
        quality: {
          ideal: 'Ideal',
          possible: 'Möglich',
          reject: 'Ablehnen',
        },
      },
    },
    chatbotTab: {
      edit: 'Edit Chatbot',
      header: 'Chatbot Preview',
      infoText:
        'This is the chatbot that will be displayed to your potential applicants.',
      unpublishedChanges:
        'You have unpublished changes - open the editor to publish them.',
      generatedAutomatically:
        'This chatbot was generated automatically. Feel free to edit it as you like.',
      live: 'Live',
    },
    creativesTab: {
      editPost: 'Edit Post',
      editStory: 'Edit Story',
    },
    creativeBuilder: {
      saveSceneInJob: 'Save project file',
      updateCreativesInJob: 'Update creatives',
      errors: {
        saveSceneError: 'Error saving project file',
        updateCreativesError: 'Error updating creatives',
      },
      stockImages: {
        actions: {
          generate: 'Generate Stock Images',
        },
        errors: {
          failedToGenerate: 'Failed to generate stock images',
          failedToUpdateFavorite: 'Error updating favorites. Please try again.',
          maxFavoritesReached: 'Maximum favorite images reached',
          missingAdText:
            'Please enter the ad text before generating suitable images.',
          invalidJobStatus:
            'The ad must have the status "Online" or "Submitted" to generate stock images.',
          generationInProgress:
            'Image generation is already in progress. Please wait until it is complete.',
        },
      },
      dock: {
        templates: 'Templates',
        jobImages: 'Job Images',
        employerBrandImages: 'Employer Brand Images',
        stockImages: 'AI Gen Images',
        assets: 'Assets',
      },
    },
  },
  organizationDetails: {
    details: 'Details',
    billingSection: 'Billing Information',
    recruiter: 'Recruiter',
    jobs: 'Jobs',
    contact: 'Schedule a Meeting',
    addRecruiter: 'Add Recruiter',
    contactEmail: 'Contact',
    homepage: 'Website',
    branch: 'Industry',
    numberOfEmployees: 'Number of Employees',
    credit: 'Credit',
    street: 'Street, House Number',
    zipCode: 'ZIP Code',
    city: 'City',
    country: 'Country',
    vatNo: 'VAT ID',
    billingEmail: 'Billing Contact (Email)',
    name: 'Organization Name',
    paymentByInvoice: 'Payment by Invoice',

    errorMessages: {
      unknownError: 'An unknown error occurred. Please try again later.',
    },
  },
  priceWidget: {
    priceCalculatedFor: 'Budget calculated for:',
    runtime_one: '1 month',
    runtime_other: '{{count}} months',
    reach: '+{{value, number}}',
    boost: 'Boost',
    impressions: '+{{value, number}} impressions',
    monthlyBudget: 'Monthly Budget',
    totalCost_one: 'Total cost for 1 month',
    totalCost_other: 'Total cost for {{count}} months',
    perMonth: ' / month',
    terms:
      'Your campaign can be canceled monthly or will automatically be renewed for another month.',
    hires_one: '1 employee',
    hires_other: '{{count}} employees',
  },
  registerSidepanel: {
    heading: 'Publish social recruiting ads now.',
    subTitle: 'Your Key Success Factors',
    passiveJobSeekers: 'Reach passive job seekers on social media',
    prequalifyCandidates: 'Prequalify candidates with a chatbot',
    optimization: 'AI optimization based on top applicants',
    findTopApplicants: 'Find top applicants in 3 steps',
    step1: 'Create an employer account',
    step2: 'Define the applicant profile',
    step3: 'Publish the social recruiting campaign',
  },
  onBeforeUnload: {
    message: 'The page has unsaved changes. Still want to leave?',
  },
} as const;
